import { render } from "./TableCheckbox.vue?vue&type=template&id=5cfa3864&scoped=true"
import script from "./TableCheckbox.vue?vue&type=script&lang=js"
export * from "./TableCheckbox.vue?vue&type=script&lang=js"

import "./TableCheckbox.vue?vue&type=style&index=0&id=5cfa3864&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfa3864"]])

export default __exports__